import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
    en: {
        // nav
        nav_index: "Index", nav_artists: "Artists", nav_events: "Events", nav_shop: "Shop", nav_about: "About", nav_embed: "Embed", nav_lab: "Lab", nav_admin: "Admin", nav_studio: "Studio", nav_contact: "Contact",
        header_shop_cta: "shop →",
        // hero
        hero_kicker: "collective / label",
        hero_tag: "a label standing for the creative freedom of music, party and artists — djs, rappers, producers, visual artists and creative programmers under one roof.",
        hero_cta_roster: "Artist list",
        hero_cta_events: "upcoming nights",
        hero_carousel_cta: "learn more",
        // sections
        just_dropped: "just dropped",
        latest_heading: "latest",
        see_all_shop: "see the whole shop →",
        objects_in_stock: "objects in stock",
        shop_all: "shop all →",
        featured_artists: "featured artists",
        section_roster: "01 / roster",
        section_agenda: "02 / agenda",
        section_av: "av / multimedia",
        section_collabs: "03 / collabs",
        section_manifesto: "04 / why",
        // shop filters
        shop_sort_by: "sort",
        shop_sort_added: "newest",
        shop_sort_price_asc: "price ↑",
        shop_sort_price_desc: "price ↓",
        shop_sort_favorites: "most loved",
        shop_filter_artist: "artist",
        shop_filter_type: "type",
        shop_filter_all: "all",
        shop_results_count: "{n} items",
        // multimedia lab
        section_lab: "05 / lab",
        lab_kicker: "multimedia lab",
        lab_title: "sound → distortion.",
        lab_intro: "click and drag on the image — the harder you drag, the more it glitches. pixel-heavy, tactile, and 100% client-side.",
        lab_default_hint: "no image set yet — pick one in admin → site → multimedia lab.",
        upcoming: "upcoming",
        full_agenda: "full agenda →",
        see_more: "see more →",
        featured_artist_kicker: "featured artist / signal",
        more_from_artist: "more from this artist",
        all_arrow: "all →",
        shop_intro: "merch, prints and tapes — pressed in small batches. checkout runs on shopify.",
        view_profile: "view profile →",
        shop_kicker: "in stock — shop",
        section_studio: "studio · collabs",
        studio_teaser_h: "we build the stages too.",
        studio_teaser_body: "creative coding, audio-reactive systems, led shows, custom rigs and brand collaborations. the same hands behind the parties design the stages, the posters, the tapes.",
        studio_cta: "into the studio →",
        contact_h: "let's talk.",
        contact_intro: "bookings, licensing, press or just want to say hi — pick a signal.",
        // av
        av_h: "we do\nmultimedia.",
        av_body: "creative coding, audio-reactive systems, led shows, music gear installations, live-coded visuals. this is a real practice inside the collective — the same hands behind the parties also design the stages.",
        av_preview_kicker: "live preview — move the mouse",
        av_open_lab: "see the whole lab →",
        av_led: "led walls · projections",
        av_led_sub: "touchdesigner · resolume · custom rigs",
        av_code: "creative coding · shaders",
        av_code_sub: "hydra · glsl · openframeworks · p5",
        av_gen: "generative music · live modular",
        av_gen_sub: "max/msp · supercollider · eurorack",
        // collabs
        collabs_h: "collaborations.",
        collabs_body: "we don't work alone. brands, venues, festivals, labels, artists — the katu signal is built with people who share the frequency.",
        collabs_cta: "let's talk",
        collabs_prompt: "got something to build together?",
        collabs_kinds: "brands · venues · festivals · artists",
        // manifesto
        manifesto_h: "artists who don't ask for permission.",
        manifesto_body_1: "itzkatu is the home of djs, rappers, producers, visual artists and coders who don't wait for a green light. relentless, talented, doing the work whether anyone is watching or not. we make sure people watch.",
        manifesto_body_2: "we share what they build with anyone who wants to be part of it — and yes, we sell it, because most of what we release is what we'd already buy ourselves.",
        manifesto_cta: "read the whole thing →",
        // events
        tickets: "tickets →",
        venue: "venue →",
        sold_out: "sold out",
        // shop
        buy_shopify: "buy on shopify →",
        visit_full_store: "visit full store",
        // artist page
        listen_watch: "listen · watch",
        tracks: "tracks",
        works: "works",
        back_to_roster: "← back to roster",
        next_show: "catch the next show →",
        // about
        about_kicker: "about / manifesto",
        about_h: "we are a label. we are a party. we are the artists.",
        // footer
        footer_navigate: "navigate",
        footer_signal: "signal",
        // marquee
        marquee_line: "creative freedom · music · party · artists",
        // artist categories (broad editorial)
        cat_all: "all",
        cat_featured: "featured",
        cat_music: "music",
        cat_visual_arts: "visual arts",
        cat_objects: "objects",
        cat_apparel: "apparel",
        cat_collective: "collective",
        artist_roster_kicker: "the roster",
        artist_intro: "a living archive of the people, sounds and objects orbiting itzkatu. every profile leads to their music, work, drops and next shows.",
        artist_search_ph: "search by name, discipline, city…",
        latest_work: "latest work",
        visit_profile: "visit profile",
        no_results: "nothing here — try another category or clear the search.",
        // scene section (editorial curated blocks — replaces old media player)
        scene_kicker: "the scene",
        scene_title: "on rotation.",
        scene_intro: "a curated cross-section of what's happening across the collective — releases, artwork, drops, nights, collaborations. one signal per feature.",
        scene_related: "also worth your time",
        scene_collaborators: "collaborators",
        scene_more: "learn more →",
        scene_tag_new: "new",
        scene_tag_featured: "featured",
    },
    es: {
        nav_index: "Inicio", nav_artists: "Artistas", nav_events: "Eventos", nav_shop: "Tienda", nav_about: "Sobre", nav_embed: "Embed", nav_lab: "Lab", nav_admin: "Admin", nav_studio: "Studio", nav_contact: "Contacto",
        header_shop_cta: "tienda →",
        hero_kicker: "colectivo / sello",
        hero_tag: "un sello por la libertad creativa de la música, la fiesta y los artistas — djs, raperos, productores, artistas visuales y programadores creativos bajo un mismo techo.",
        hero_cta_roster: "Lista de artistas",
        hero_cta_events: "próximas noches",
        hero_carousel_cta: "más info",
        just_dropped: "recién llegado",
        latest_heading: "lo nuevo",
        see_all_shop: "ver toda la tienda →",
        objects_in_stock: "objetos disponibles",
        shop_all: "ver toda la tienda →",
        featured_artists: "artistas destacados",
        section_roster: "01 / roster",
        section_agenda: "02 / agenda",
        section_av: "av / multimedia",
        section_collabs: "03 / colabs",
        section_manifesto: "04 / porqué",
        // shop filters
        shop_sort_by: "orden",
        shop_sort_added: "más nuevos",
        shop_sort_price_asc: "precio ↑",
        shop_sort_price_desc: "precio ↓",
        shop_sort_favorites: "más queridos",
        shop_filter_artist: "artista",
        shop_filter_type: "tipo",
        shop_filter_all: "todos",
        shop_results_count: "{n} objetos",
        // multimedia lab
        section_lab: "05 / lab",
        lab_kicker: "multimedia lab",
        lab_title: "sonido → distorsión.",
        lab_intro: "hacé click y arrastrá sobre la imagen — mientras más fuerte arrastres, más se glitchea. pura pixel-cirugía, táctil y 100% en tu navegador.",
        lab_default_hint: "sin imagen todavía — elegí una en admin → site → multimedia lab.",
        upcoming: "próximos",
        full_agenda: "agenda completa →",
        see_more: "ver más →",
        featured_artist_kicker: "artista destacado / señal",
        more_from_artist: "más de este artista",
        all_arrow: "ver todos →",
        shop_intro: "merch, prints y cassettes — impresos en tiradas cortas. el checkout corre en shopify.",
        view_profile: "ver perfil →",
        shop_kicker: "en stock — tienda",
        section_studio: "studio · colabs",
        studio_teaser_h: "también armamos los escenarios.",
        studio_teaser_body: "código creativo, sistemas audio-reactivos, muros led, rigs a medida y colaboraciones con marcas. las mismas manos que arman las fiestas diseñan los escenarios, los afiches y las cassettes.",
        studio_cta: "entrar al studio →",
        contact_h: "hablemos.",
        contact_intro: "bookings, licencias, prensa o simplemente saludar — elegí una señal.",
        av_h: "hacemos\nmultimedia.",
        av_body: "código creativo, sistemas audio-reactivos, muros led, instalaciones de equipos musicales, visuales en vivo con código. es una práctica real dentro del colectivo — las mismas manos que arman las fiestas diseñan los escenarios.",
        av_preview_kicker: "preview en vivo — mové el mouse",
        av_open_lab: "ver todo el lab →",
        av_led: "muros led · proyecciones",
        av_led_sub: "touchdesigner · resolume · rigs a medida",
        av_code: "código creativo · shaders",
        av_code_sub: "hydra · glsl · openframeworks · p5",
        av_gen: "música generativa · modular en vivo",
        av_gen_sub: "max/msp · supercollider · eurorack",
        collabs_h: "colaboraciones.",
        collabs_body: "no trabajamos solos. marcas, venues, festivales, sellos, artistas — la señal katu se construye con quienes comparten la frecuencia.",
        collabs_cta: "hablemos",
        collabs_prompt: "¿tenés algo para construir juntos?",
        collabs_kinds: "marcas · venues · festivales · artistas",
        manifesto_h: "artistas que no piden permiso.",
        manifesto_body_1: "itzkatu es la casa de djs, raperos, productores, artistas visuales y programadores que no esperan luz verde. incansables, talentosos, y trabajando aunque nadie mire. nosotros nos encargamos de que miren.",
        manifesto_body_2: "compartimos lo que construyen con cualquiera que quiera ser parte — y sí, lo vendemos, porque casi todo lo que sacamos es lo que ya compraríamos nosotros mismos.",
        manifesto_cta: "leer todo →",
        tickets: "entradas →",
        venue: "venue →",
        sold_out: "agotado",
        buy_shopify: "comprar en shopify →",
        visit_full_store: "ir a la tienda completa",
        listen_watch: "escuchá · mirá",
        tracks: "tracks",
        works: "obras",
        back_to_roster: "← volver al roster",
        next_show: "no te pierdas el próximo show →",
        about_kicker: "sobre / manifiesto",
        about_h: "somos un sello. somos una fiesta. somos los artistas.",
        footer_navigate: "navegar",
        footer_signal: "señal",
        marquee_line: "libertad creativa · música · fiesta · artistas",
        cat_all: "todos",
        cat_featured: "destacados",
        cat_music: "música",
        cat_visual_arts: "artes visuales",
        cat_objects: "objetos",
        cat_apparel: "indumentaria",
        cat_collective: "colectivo",
        artist_roster_kicker: "el roster",
        artist_intro: "un archivo vivo de las personas, sonidos y objetos que orbitan a itzkatu. cada perfil lleva a su música, obra, drops y próximos shows.",
        artist_search_ph: "buscá por nombre, disciplina, ciudad…",
        latest_work: "última obra",
        visit_profile: "ver perfil",
        no_results: "nada acá — probá otra categoría o limpiá la búsqueda.",
        scene_kicker: "la escena",
        scene_title: "en rotación.",
        scene_intro: "una selección editorial de lo que está pasando en el colectivo — lanzamientos, obra, drops, noches, colabs. una señal por feature.",
        scene_related: "también vale tu tiempo",
        scene_collaborators: "colaboradores",
        scene_more: "más info →",
        scene_tag_new: "nuevo",
        scene_tag_featured: "destacado",
    },
};

const LangCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {}, currency: "USD", setCurrency: () => {} });

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        const stored = localStorage.getItem("itzkatu_lang");
        if (stored) return stored;
        // Aggressive geo/lang detection for first-time visitors so a mobile user
        // in Mexico gets ES even if their system language is en-US.
        try {
            // 1) Timezone: any Latin American / Iberian timezone → ES
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
            const LATAM_TZ = /^(America\/(Mexico|Tijuana|Merida|Monterrey|Cancun|Chihuahua|Hermosillo|Mazatlan|Bogota|Lima|Buenos_Aires|Santiago|Caracas|La_Paz|Asuncion|Montevideo|Guatemala|Tegucigalpa|Managua|San_Salvador|Costa_Rica|Panama|Havana|Santo_Domingo|Guayaquil|Argentina|Cordoba|Mendoza|Rosario|Jujuy|Salta|Ushuaia)|Atlantic\/Canary|Europe\/Madrid)/i;
            if (LATAM_TZ.test(tz)) return "es";
        } catch { /* ignore */ }
        // 2) navigator.languages (array of preferred langs, most reliable)
        try {
            const langs = (typeof navigator !== "undefined" && Array.isArray(navigator.languages))
                ? navigator.languages
                : [(navigator && (navigator.language || navigator.userLanguage)) || "en"];
            if (langs.some((l) => /^(es|pt|ca|gl)/i.test(l))) return "es";
        } catch { /* ignore */ }
        return "en";
    });
    // Currency mirrors language by default: EN → USD, ES → MXN. Users can still
    // toggle it manually inside the shop, but changing language RE-syncs it
    // so the header pair always reads as one truth (en/usd or es/mxn).
    const [currency, setCurrencyState] = useState(() => {
        const stored = localStorage.getItem("itzkatu_currency");
        if (stored) return stored;
        return lang === "es" ? "MXN" : "USD";
    });
    useEffect(() => {
        localStorage.setItem("itzkatu_lang", lang);
        document.documentElement.lang = lang;
        // Re-sync currency to match the newly picked language.
        const paired = lang === "es" ? "MXN" : "USD";
        setCurrencyState(paired);
        localStorage.setItem("itzkatu_currency", paired);
    }, [lang]);
    useEffect(() => {
        localStorage.setItem("itzkatu_currency", currency);
    }, [currency]);
    const setLang = (l) => setLangState(l);
    const setCurrency = (c) => setCurrencyState(c);
    const t = (k) => (DICT[lang] && DICT[lang][k]) || DICT.en[k] || k;
    return <LangCtx.Provider value={{ lang, t, setLang, currency, setCurrency }}>{children}</LangCtx.Provider>;
};

export const useT = () => useContext(LangCtx);
